import AnswerForm from './AnswerForm'

export default AnswerForm
